import { Twitter, Linkedin, Facebook, MessageCircle, Mail, Share2 } from "lucide-react";

const DEFAULT_MESSAGE = "I'm using FastPrototype.ai to get MVPs built in 1–4 weeks with AI + senior developer oversight. Fixed price, no surprises.";

export default function SocialShare({ url, message = DEFAULT_MESSAGE, compact = false }) {
  const shareUrl = url || (typeof window !== "undefined" ? window.location.origin : "https://fastprototype.ai");
  const enc = encodeURIComponent;

  const networks = [
    { key: "twitter", label: "X / Twitter", icon: Twitter, color: "hover:bg-black hover:text-white",
      href: `https://twitter.com/intent/tweet?text=${enc(message)}&url=${enc(shareUrl)}` },
    { key: "linkedin", label: "LinkedIn", icon: Linkedin, color: "hover:bg-[#0a66c2] hover:text-white",
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${enc(shareUrl)}` },
    { key: "facebook", label: "Facebook", icon: Facebook, color: "hover:bg-[#1877f2] hover:text-white",
      href: `https://www.facebook.com/sharer/sharer.php?u=${enc(shareUrl)}` },
    { key: "whatsapp", label: "WhatsApp", icon: MessageCircle, color: "hover:bg-[#25D366] hover:text-white",
      href: `https://wa.me/?text=${enc(`${message} ${shareUrl}`)}` },
    { key: "email", label: "Email", icon: Mail, color: "hover:bg-zinc-950 hover:text-white",
      href: `mailto:?subject=${enc("You might like FastPrototype.ai")}&body=${enc(`${message}\n\n${shareUrl}`)}` },
  ];

  if (compact) {
    return (
      <div className="flex items-center gap-1.5" data-testid="social-share-compact">
        {networks.map(n => (
          <a key={n.key} href={n.href} target="_blank" rel="noopener noreferrer" data-testid={`share-${n.key}`}
            title={`Share on ${n.label}`} aria-label={`Share on ${n.label}`}
            className={`w-8 h-8 rounded-full border border-zinc-200 flex items-center justify-center text-zinc-600 transition-colors ${n.color}`}>
            <n.icon size={13} />
          </a>
        ))}
      </div>
    );
  }

  return (
    <div className="bg-white border border-zinc-200 rounded-3xl p-6" data-testid="social-share-card">
      <div className="flex items-center gap-2 mb-3">
        <Share2 size={16} className="text-zinc-700" />
        <h3 className="font-bold text-zinc-950 text-sm">Help us spread the word</h3>
      </div>
      <p className="text-xs text-zinc-500 mb-4">One click share — choose where you hang out.</p>
      <div className="flex flex-wrap gap-2" data-testid="social-share-buttons">
        {networks.map(n => (
          <a key={n.key} href={n.href} target="_blank" rel="noopener noreferrer" data-testid={`share-${n.key}`}
            className={`inline-flex items-center gap-2 px-4 py-2 rounded-full border border-zinc-200 text-xs font-semibold text-zinc-700 transition-colors ${n.color}`}>
            <n.icon size={13} /> {n.label}
          </a>
        ))}
      </div>
    </div>
  );
}
